<template>
  <div class="form-entry row row-cols-1">
    <template v-if="notifyingEstablishment">
      <div class="col form-entry__establishment-name">
        <h1>Notifying the establishment that you might be interested in an upgrade...</h1>
      </div>
      <div class="form-entry__loading">
        <Spinner colour="#242F3E"/>
      </div>
    </template>

    <template v-else>
      <div class="col form-entry__establishment-name" v-bind:class="{'form-entry__establishment-image' : hasLogo}">
        <img v-if="hasLogo" v-bind:src="upgradeRequestResponse.establishmentImageURL"/>
<!--        <img v-if="hasLogo" src='https://s3.af-south-1.amazonaws.com/media.dev.swiftly.co.za/RhOnaV1FuQP5S1tr39XCOMpWGUGbIUoX.png'>-->
        <h1 v-else>{{upgradeRequestResponse.establishmentName}}</h1>
      </div>

      <p>
        Hi {{upgradeRequestResponse.guestName}}
      </p>
      <p>
        Thank you for expressing interest in an upgrade from
        {{upgradeRequestResponse.fromRoomType}} to {{upgradeRequestResponse.toRoomType}}
        at one of our special discounted rates. One of our team will contact you shortly to answer any questions
        you may have and to help you make a decision.
      </p>
      <p>
        Kind regards<br>
        {{upgradeRequestResponse.establishmentName}}
      </p>

<!--      <img v-if='upgradeRequestResponse.establishmentImageURL' v-bind:src='upgradeRequestResponse.establishmentImageURL'>-->
    </template>
  </div>
</template>

<script>
import Spinner from '../components/Spinner'

export default {
  name: 'Upgrade',
  components: { Spinner },
  props: {
    bookingReference: String
  },
  data: function () {
    return {
      upsellReference: null,
      fromRoomTypeReference: null,
      toRoomTypeReference: null,
      notifyingEstablishment: true,
      upgradeRequestResponse: null,
      errorMessage: null
    }
  },
  computed: {
    hasLogo: function () {
      if (this.upgradeRequestResponse && this.upgradeRequestResponse.establishmentImageURL) {
        return true
      }
      return false
    }
  },
  methods: {
    informEstablishment: async function () {
      const body = {
        reference: this.upsellReference,
        fromRoomTypeReference: this.fromRoomTypeReference,
        toRoomTypeReference: this.toRoomTypeReference
      }
      this.$http.post('/guest/v1/bookings/' + this.bookingReference + '/upgrade-enquire', body).then(response => {
        this.upgradeRequestResponse = response.data
      }).catch(error => {
        if (error.response) {
          console.log(error.response.data)
          if (error.response.status === 500) {
            this.errorMessage = 'Sorry, but there was a problem notifying the establishment. Please try refreshing the page.'
          } else {
            this.errorMessage = error.response.data.message
          }
        } else {
          this.errorMessage = 'Sorry, but there was a problem notifying the establishment. Please try refreshing the page.'
        }
      }).finally(() => {
      // setTimeout(() => {
      //   console.log('waited')
        this.notifyingEstablishment = false
      // }, 1000)
      })
    }
  },
  mounted () {
    console.log('Guest is requesting info on an upgrade')
    this.upsellReference = this.$route.query.ref
    this.fromRoomTypeReference = this.$route.query.from
    this.toRoomTypeReference = this.$route.query.to
    this.informEstablishment()
  }
}

</script>

<style lang="scss" scoped>
  @import "../styles/base/base.scss";
  @import "../styles/components/form_entry";
</style>
